import dayjs from "dayjs";

export const daysFilterValue = [
  {
    text: 'today',
    value: new Date(dayjs().startOf('day').add(0, 'day')),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'yesterday',
    value: new Date(dayjs().startOf('day').add(-1, 'day')),
    value2: new Date(dayjs().startOf('day').add(0, 'day')),
  },
  {
    text: 'currentWeek',
    value: new Date(dayjs().startOf('day').day(1)),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'currentMonth',
    value: new Date(dayjs().startOf('day').date(1)),
    value2: new Date(dayjs().startOf('day').add(1, 'day')),
  },
  {
    text: 'lastWeek',
    value: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').day() + 7 - 1), 'day'),
    ),
    value2: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').day() + 0 - 1), 'day'),
    ),
  },
  {
    text: 'lastMonth',
    value: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').date() + dayjs().startOf('day').add(-1, 'month').daysInMonth() - 1), 'day'),
    ),
    value2: new Date(
      dayjs()
        .startOf('day')
        .add(-(dayjs().startOf('day').date() + 0 - 1), 'day'),
    ),
  },
];
